class InfiniteScroll {
  constructor() {
    this.grid = document.getElementById('product-grid');
    this.sentinel = document.querySelector('.infinite-scroll');
    if (!this.grid || !this.sentinel) return;

    this.loading = false;
    this.spinner = this.createSpinner();
    this.hidePagination();

    this.onScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    
    // Run an instant check on load in case the screen is tall
    setTimeout(() => this.onScroll(), 200);
  }

  hidePagination() {
    const nav = document.querySelector('.pagination-wrapper');
    if (nav) nav.style.display = 'none';
  }

  createSpinner() {
    const style = document.createElement('style');
    style.textContent = `
      .is-spinner {
        display: none;
        justify-content: center;
        align-items: center;
        padding: 3rem 0;
        width: 100%;
        clear: both;
        position: relative;
        z-index: 999;
      }
      .is-spinner.visible { display: flex; }
      .is-spinner__dot {
        width: 12px; height: 12px;
        margin: 0 6px;
        border-radius: 50%;
        background: #1A1A1A; /* Force matte black color to match your branding explicitly */
        animation: is-bounce 1.2s ease-in-out infinite;
      }
      .is-spinner__dot:nth-child(2) { animation-delay: 0.2s; }
      .is-spinner__dot:nth-child(3) { animation-delay: 0.4s; }
      @keyframes is-bounce {
        0%, 80%, 100% { transform: scale(0.6); opacity: 0.3; }
        40% { transform: scale(1.2); opacity: 1; }
      }
    `;
    document.head.appendChild(style);

    const spinner = document.createElement('div');
    spinner.className = 'is-spinner';
    spinner.innerHTML = `
      <div class="is-spinner__dot"></div>
      <div class="is-spinner__dot"></div>
      <div class="is-spinner__dot"></div>
    `;
    
    // INJECTION FIX: Append it safely INSIDE the parent container so it doesn't clip out
    this.grid.parentNode.appendChild(spinner);
    return spinner;
  }

  onScroll() {
    if (this.loading) return;

    // MOBILE VIEWPORT MATH ADJUSTMENT:
    // We use bounding client calculations instead of absolute page heights 
    // to bypass mobile browser address bar layout shifts.
    const sentinelRect = this.sentinel.getBoundingClientRect();
    const triggerThreshold = window.innerHeight + 800; // Load when sentinel is 800px below screen viewport

    if (sentinelRect.top <= triggerThreshold) {
      this.loadMore();
    }
  }

  async loadMore() {
    const nextUrl = this.sentinel.dataset.nextUrl;
    if (!nextUrl || this.loading) return;
    this.loading = true;
    this.spinner.classList.add('visible');

    try {
      const res = await fetch(nextUrl);
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');

      doc.querySelectorAll('#product-grid > li').forEach((li) => {
        li.classList.remove('scroll-trigger', 'animate--slide-in');
        li.removeAttribute('data-cascade');
        li.style.removeProperty('--animation-order');
        this.grid.appendChild(li);
      });

      const nextSentinel = doc.querySelector('.infinite-scroll');
      if (nextSentinel && nextSentinel.dataset.nextUrl) {
        this.sentinel.dataset.nextUrl = nextSentinel.dataset.nextUrl;
      } else {
        window.removeEventListener('scroll', this.onScroll);
        this.sentinel.remove();
      }
    } catch (err) {
      console.error('Infinite scroll error:', err);
    } finally {
      this.loading = false;
      this.spinner.classList.remove('visible');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => new InfiniteScroll());